import React, { useMemo } from 'react'

import { FeedbackAndQuestionNoticeListItem } from '../../../common/validations/feedbackAndQuestionNotice'
import { useAPIGetQuestionNoticesSuspense } from '../../api/apiHooks/useAPIGetQuestionNotices'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

import { useAPIGetFeedbackNoticesSuspense } from 'api/apiHooks/useAPIGetFeedbackNotices'

type Data = {
  feedbackAndQuestionNotices: FeedbackAndQuestionNoticeListItem[]
}

export const ContactInfoSidebarDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: feedbackNotices } =
    useAPIGetFeedbackNoticesSuspense(currentContractId)
  const { data: questionNotices } =
    useAPIGetQuestionNoticesSuspense(currentContractId)

  const feedbackAndQuestionNotices = useMemo(() => {
    const combined = [...questionNotices, ...feedbackNotices]
    const noticeMap = new Map(
      combined.map((notice) => [notice.id, notice] as const)
    )
    return Array.from(noticeMap.values()).sort(
      (a, b) => Number(b.id) - Number(a.id)
    )
  }, [questionNotices, feedbackNotices])

  return children({
    feedbackAndQuestionNotices,
  })
}
